import { Text, Stack } from "@mantine/core";
import Link from "@/components/Link";
import styles from "./styles.module.scss";

type Props = {
  title: string;
  description?: string;
  link: string;
  mobileGridPlacement?: boolean;
};

const SeeMoreCard = ({ title, description, link, mobileGridPlacement = false }: Props) => {
  return (
    <Link
      href={link}
      className={`${styles.seeMoreCard} ${mobileGridPlacement ? styles.mobileGridSeeMore : ""}`}
      data-mobile-grid-see-more={mobileGridPlacement || undefined}
      aria-label={description || title}
    >
      <Stack gap={description ? 4 : 0} className={styles.seeMoreContent}>
        <Text className={styles.seeMoreText}>{title}</Text>
        {description && <Text className={styles.seeMoreDescription}>{description}</Text>}
        <Text className={styles.arrow}>→</Text>
      </Stack>
    </Link>
  );
};

export default SeeMoreCard;
